import { produce } from 'immer';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED, UPDATE_CONTENT_MODEL_USE_FEATURED_IMAGE, UPDATE_CONTENT_MODEL_FEATURED_IMAGE, CLEAR_CONTENT_MODEL_FEATURED_IMAGE } from 'ContentEditorUI/redux/actions/actionTypes';
import { Map as ImmutableMap } from 'immutable';
const initialState = {
  featuredImage: '',
  featuredImageAltText: '',
  useFeaturedImage: false
};
export const featuredImageReducerAsJSObject = (state = initialState, {
  type,
  payload,
  response
}) => produce(state, draft => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const {
          content
        } = response;
        return Object.assign(draft, {
          featuredImage: content.featuredImage,
          featuredImageAltText: content.featuredImageAltText,
          useFeaturedImage: content.useFeaturedImage
        });
      }
    case UPDATE_CONTENT_MODEL_USE_FEATURED_IMAGE:
      return Object.assign(draft, {
        featuredImage: payload.featuredImage,
        useFeaturedImage: payload.useFeaturedImage
      });
    case UPDATE_CONTENT_MODEL_FEATURED_IMAGE:
      return Object.assign(draft, {
        featuredImage: payload.featuredImage,
        featuredImageAltText: payload.featuredImageAltText
      });
    case CLEAR_CONTENT_MODEL_FEATURED_IMAGE:
      return Object.assign(draft, {
        featuredImage: '',
        featuredImageAltText: ''
      });
    default:
      return draft;
  }
});
const featuredImageReducer = (state = ImmutableMap(initialState), {
  type,
  payload,
  response
}) => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const {
          content
        } = response;
        return state.merge({
          featuredImage: content.featuredImage,
          featuredImageAltText: content.featuredImageAltText,
          useFeaturedImage: content.useFeaturedImage
        });
      }
    case UPDATE_CONTENT_MODEL_USE_FEATURED_IMAGE:
      return state.merge({
        featuredImage: payload.featuredImage,
        useFeaturedImage: payload.useFeaturedImage
      });
    case UPDATE_CONTENT_MODEL_FEATURED_IMAGE:
      return state.merge({
        featuredImage: payload.featuredImage,
        featuredImageAltText: payload.featuredImageAltText
      });
    case CLEAR_CONTENT_MODEL_FEATURED_IMAGE:
      return state.merge({
        featuredImage: '',
        featuredImageAltText: ''
      });
    default:
      return state;
  }
};
export default featuredImageReducer;